import script from "./PriceData.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceData.vue?vue&type=script&setup=true&lang=js"

import "./PriceData.vue?vue&type=style&index=0&id=0846ebb2&lang=scss"

const __exports__ = script;

export default __exports__